import React from 'react';
import {
  ListSocialLeft,
  ListSocialRight,
  CopyRight,
  ListMenuFooter
} from './sub-footer';

class Footer extends React.Component {

  render() {
    return (
      <footer className="footer-container" id='footer'>
        {/* <div className='footer-top'>
          <div className='center'>
            <ListMenuFooter/>
          </div>
        </div> */}
        <div className='footer-bottom'>
          <div className='center'>
            <CopyRight/>
            <div className='right-content'>
              <ListSocialLeft/>
              <ListSocialRight/>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./components/layouts/master/Footer.jsx